export var getImageUrl = function getImageUrl(name) {
  return "".concat(window.location.origin, "/wp-content/plugins/tatum/public/assets/").concat(name);
};